import React from 'react'

const SlideSeven = () => (
  <div className="slide">
    <img src="/ski-lift.png" alt="Zeronomics" className="ski-lift" />
  </div>
)

export default SlideSeven
